export interface UserListItem {
  id: string;
  username: string;
  email: string;
  firstName: string;
  lastName: string;
}

export enum UserGroup {
  Admin = 'Admin',
  Issuer = 'Issuer',
  InvestorIndividual = 'Investor_Individual',
  InvestorCompany = 'Investor_Company',
}

export const DEFAULT_ROLE_TITLE = 'Owner';

export interface UserRoleProfile {
  companyName?: string;
  signature?: string;
  initials?: string;
}

export interface UserRole {
  id: string;
  group: string;
  title: string;
  companyName: string | null;
  firstName: string | null;
  lastName: string | null;
  termOfMarketing: boolean | null;
  referralCode: string | null;
  userProfile: UserRoleProfile | null;
}

export interface UserDetailUser {
  id: string;
  username: string;
  email: string;
  displayName: string;
  firstName: string;
  lastName: string;
  profilePicture: string;
  activeRoleId: string | null;
  createdAt: string;
  updatedAt: string;
  veriffExempt?: boolean;
  veriffExemptSetBy?: string | null;
  veriffExemptSetAt?: string | null;
}

export interface UserDetailInvestor {
  entityType: string | null;
  fullName: string;
  personalPhone: string;
  personalAddress: Record<string, unknown>;
  photoId: string;
  kycApproved: boolean;
  kycSubmitted: boolean;
  emdApprovals: Record<string, boolean>;
}

export interface UserDetailIssuerCompanyProfile {
  type: string;
  corporateName: string;
  corporateNumber: string;
  dateIncorporated: string;
  registeredAddress: string;
  corporateEmail: string;
  corporatePhone: string;
  companyLogo: string;
  documentCounts: Record<string, number>;
}

export interface UserDetailIssuer {
  companyProfile: UserDetailIssuerCompanyProfile;
  authorizedRepresentativesCount: number;
}

export type AccountStatus =
  | 'UNCONFIRMED'
  | 'CONFIRMED'
  | 'ARCHIVED'
  | 'COMPROMISED'
  | 'RESET_REQUIRED'
  | 'FORCE_CHANGE_PASSWORD'
  | 'EXTERNAL_PROVIDER'
  | 'UNKNOWN';

export interface UserDetailResponse {
  user: UserDetailUser;
  roles: UserRole[];
  investor: UserDetailInvestor | null;
  issuer: UserDetailIssuer | null;
  accountStatus?: AccountStatus;
}

export interface UserPortfolioItem {
  id: string;
  userId: string;
  userName: string;
  email: string;
  roleId: string;
  roleGroup: string;
  roleLabel: string;
  projectId: string;
  projectName: string;
  propertyId: string;
  propertyName: string;
  amount: number;
  status: string;
  currentStep: string;
  createdAt: string;
  updatedAt: string;
}

export interface CreateUserRolePayload {
  group: string;
  role: string;
  firstName?: string;
  lastName?: string;
  companyName?: string;
}

export interface CreateUserPayload {
  email: string;
  roles: CreateUserRolePayload[];
  sendEmail?: boolean;
}

export interface CreateUserResponse {
  userId: string;
  email: string;
  roles: { roleId: string; group: string; role: string }[];
  existing: boolean;
  tempPassword: string | null;
  emailSent: boolean;
  repaired: boolean;
}

export interface ResendTempPasswordResponse {
  tempPassword: string | null;
  emailSent: boolean;
}

export interface AddRolePayload extends CreateUserRolePayload {
  userId: string;
}

export interface UpdateRolePayload {
  userId: string;
  roleId: string;
  firstName?: string;
  lastName?: string;
  companyName?: string;
}
